import { gapi } from "gapi-script";

const CLIENT_ID = `${process.env.REACT_APP_CLIENT_ID}`;
const SCOPES = "https://www.googleapis.com/auth/drive";

let accessToken = null;

const initializeGapi = async () => {
  return new Promise((resolve, reject) => {
    gapi.load("client:auth2", async () => {
      try {
        await gapi.client.init({
          clientId: CLIENT_ID,
          scope: SCOPES,
          redirect_uri: `${process.env.REACT_APP_REDIRECT_URI}`,
        });
        console.log("GAPI inicializado com sucesso!");
        resolve(gapi.auth2.getAuthInstance());
      } catch (error) {
        console.error("Erro ao inicializar o GAPI:", error);
        reject(error);
      }
    });
  });
};

export const authenticateUser = async () => {
  try {
    const authInstance = await initializeGapi();
    const user = await authInstance.signIn();
    const authResponse = user.getAuthResponse();

    accessToken = authResponse.access_token;

    return authResponse;
  } catch (error) {
    console.error("Erro ao autenticar o usuário:", error);
    throw error;
  }
};

export const uploadFile = async (file) => {
  if (!file || file.size === 0) {
    console.error("O arquivo está vazio ou inválido.");
    alert("Por favor, selecione um arquivo válido.");
    return;
  }

  if (!accessToken) {
    console.log("Autenticando usuário...");
    await authenticateUser();
  }

  try {
    gapi.client.setToken({ access_token: accessToken });

    const metadata = {
      name: file.name,
      mimeType: file.type,
    };

    const fileContent = await file.arrayBuffer();

    const boundary = "boundary-" + Math.random().toString(36).substr(2, 10);
    const delimiter = `\r\n--${boundary}\r\n`;
    const closeDelimiter = `\r\n--${boundary}--`;

    const multipartRequestBody =
      delimiter +
      "Content-Type: application/json; charset=UTF-8\r\n\r\n" +
      JSON.stringify(metadata) +
      delimiter +
      `Content-Type: ${file.type}\r\nContent-Transfer-Encoding: base64\r\n\r\n` +
      btoa(
        new Uint8Array(fileContent).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ""
        )
      ) +
      closeDelimiter;

    const response = await gapi.client.request({
      path: "https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart",
      method: "POST",
      headers: {
        "Content-Type": `multipart/related; boundary=${boundary}`,
      },
      body: multipartRequestBody,
    });
    return response;
  } catch (error) {
    console.error("Erro ao enviar o arquivo:", error);
    alert("Erro ao enviar o arquivo. Verifique os logs.");
  }
};

export const downloadFile = async (fileId, fileName) => {
  try {
    if (!accessToken) {
      console.log("Autenticando usuário...");
      await authenticateUser();
    }

    gapi.client.setToken({ access_token: accessToken });

    console.log("File ID:", fileId);

    const metadataResponse = await gapi.client.request({
      path: `https://www.googleapis.com/drive/v3/files/${fileId}`,
      method: "GET",
      params: {
        fields: "id, name, mimeType",
      },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const { mimeType, name } = metadataResponse.result;

    console.log("Metadados do arquivo:", metadataResponse.result);

    if (!mimeType) {
      throw new Error("O tipo MIME do arquivo não pôde ser determinado.");
    }

    const response = await fetch(
      `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Erro ao obter o arquivo: ${response.statusText}`);
    }

    const blob = await response.blob();

    if (blob.size === 0) {
      throw new Error("O arquivo está vazio.");
    }

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName || name || "downloaded_file.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Erro ao baixar o arquivo: Nenhum arquivo encontrado");
    alert("Erro ao baixar o arquivo. Nenhum arquivo encontrado.");
  }
};
